const trackingId = process.env.REACT_APP_GA_TRACKING_ID || "{}";

const GoogleAnalyticsConfig = {
    trackingId: trackingId,
    options: {
        debug: false,
        gaOptions: {
            sampleRate: 100,
            siteSpeedSampleRate: 100
        }
    }
};

export default GoogleAnalyticsConfig;
